import React from 'react';
import './PetAnimations.css';

export default function PandaSvg({ size = 120, color, className = '' }) {
  const bodyColor = '#F5F5F5';
  const darkColor = color || '#2C2C2C';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Body - very round */}
      <ellipse cx="60" cy="74" rx="32" ry="28" fill={bodyColor} />
      {/* Dark saddle */}
      <path d="M32 64C32 64 40 56 60 56C80 56 88 64 88 64L88 80C88 80 80 86 60 86C40 86 32 80 32 80Z" fill={darkColor} opacity="0.15" />
      {/* Belly */}
      <ellipse cx="60" cy="80" rx="18" ry="14" fill="white" />
      {/* Arms/legs - dark */}
      <ellipse cx="36" cy="90" rx="12" ry="8" fill={darkColor} />
      <ellipse cx="84" cy="90" rx="12" ry="8" fill={darkColor} />
      <ellipse cx="42" cy="86" rx="8" ry="10" fill={darkColor} />
      <ellipse cx="78" cy="86" rx="8" ry="10" fill={darkColor} />
      {/* Head */}
      <circle cx="60" cy="42" r="24" fill={bodyColor} />
      {/* Ears - dark */}
      <circle cx="38" cy="22" r="10" fill={darkColor} />
      <circle cx="82" cy="22" r="10" fill={darkColor} />
      {/* Eye patches - dark */}
      <ellipse cx="48" cy="40" rx="10" ry="8" fill={darkColor} transform="rotate(-15 48 40)" />
      <ellipse cx="72" cy="40" rx="10" ry="8" fill={darkColor} transform="rotate(15 72 40)" />
      {/* Eyes */}
      <circle cx="48" cy="40" r="5" fill="white" />
      <circle cx="72" cy="40" r="5" fill="white" />
      <circle cx="49" cy="40.5" r="3" fill="#1A1A1A" />
      <circle cx="73" cy="40.5" r="3" fill="#1A1A1A" />
      <circle cx="50" cy="39" r="1.2" fill="white" />
      <circle cx="74" cy="39" r="1.2" fill="white" />
      {/* Nose */}
      <ellipse cx="60" cy="50" rx="4" ry="2.5" fill={darkColor} />
      {/* Mouth */}
      <path d="M60 52.5C58 54 56 54.5 55 54" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      <path d="M60 52.5C62 54 64 54.5 65 54" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      {/* Blush */}
      <ellipse cx="44" cy="50" rx="4" ry="2.5" fill="#F8A4C8" opacity="0.3" />
      <ellipse cx="76" cy="50" rx="4" ry="2.5" fill="#F8A4C8" opacity="0.3" />
    </svg>
  );
}
